// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__8QOMW","title":"Contact_title__enxf+","links":"Contact_links__12pwp","linkCard":"Contact_linkCard__uK6oq"};